/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_A3dInputs */

const en_mk_sol_startup_a3d = /** @type {(inputs: Mk_Sol_Startup_A3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answers questions about numbers and explains how they were computed, rather than tossing out a figure.`)
};

const id_mk_sol_startup_a3d = /** @type {(inputs: Mk_Sol_Startup_A3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menjawab pertanyaan angka dan menjelaskan cara menghitungnya, bukan sekadar melempar hasil.`)
};

/**
* | output |
* | --- |
* | "Answers questions about numbers and explains how they were computed, rather than tossing out a figure." |
*
* @param {Mk_Sol_Startup_A3dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_a3d = /** @type {((inputs?: Mk_Sol_Startup_A3dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_A3dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_a3d(inputs)
	return en_mk_sol_startup_a3d(inputs)
});